<ngx-material-timepicker-face [selectedTime]="selectedHour" [faceTime]="hoursList"
                              (timeChange)="hourChange.next($event)" (timeSelected)="onTimeSelected($event)"></ngx-material-timepicker-face>
